<script setup lang="ts">
import { inject, Ref, ref } from 'vue';
import { getCurrentLocale } from '@/i18n';
import capitalize from 'lodash/capitalize';
import cloneDeep from 'lodash/cloneDeep';
import TourQuoteSearchFilter from '@/components/modal/tour/TourQuoteSearchFilter.vue';
import TourQuoteSearchList from '@/components/modal/tour/TourQuoteSearchList.vue';

const dialogRef = inject('dialogRef') as Ref;
const onApply = dialogRef?.value?.options?.emits?.onApply;
const tourSearchData = dialogRef?.value?.options.data.tourSearchData;
const selectedTours = dialogRef?.value?.options.data.selectedTours;

const currentLanguage = getCurrentLocale();
const tourData = ref(cloneDeep(tourSearchData));
const tourFilter = ref({
  depDate: '',
  tourDurations: '',
  [`tourName${capitalize(currentLanguage)}`]: [],
  type: [],
  [`regionsVisited${capitalize(currentLanguage)}`]: []
});

const filterArrayItems = (tour: any, filterItem: string) => {
  const checkTourFilterType = filterItem === 'type' && !tour[filterItem] ? '' : tour[filterItem];
  return (
    tourFilter.value[filterItem].length === 0 ||
    tourFilter.value[filterItem].some((tourFilterItem: any) =>
      checkTourFilterType
        .split(',')
        .map((value: any) => value.trim())
        .includes(tourFilterItem)
    )
  );
};

const filterArrayName = (tour: any, filterItem: string) => {
  if (!tourFilter.value[filterItem] || tourFilter.value[filterItem].length === 0) {
    return true;
  }
  if (!tour[filterItem] || typeof tour[filterItem] !== 'string') {
    return false;
  }
  const tourText = tour[filterItem].toLowerCase().trim();
  const isMatch = tourFilter.value[filterItem].some((tourFilterItem: any) => tourText.includes(tourFilterItem.toLowerCase().trim()));
  return isMatch;
};

const filterDurations = (tour: any, filterItem: string) => {
  return !tourFilter.value.tourDurations || tourFilter.value.tourDurations === tour[filterItem];
};

const handleApplyFilter = () => {
  const filterData = tourSearchData.filter((tour: any) => {
    const matchesRegion = filterArrayItems(tour, `regionsVisited${capitalize(currentLanguage)}`);
    const matchesName = filterArrayName(tour, `tourName${capitalize(currentLanguage)}`);
    const matchesType = filterArrayItems(tour, 'type');
    const matchesDuration = filterDurations(tour, 'tourDurations');
    const matchesDate = !tourFilter.value.depDate || tour.depDate == tourFilter.value.depDate;
    return matchesDate && matchesDuration && matchesName && matchesType && matchesRegion;
  });
  tourData.value = filterData;
};

const handleResetFilter = (resetVal: any) => {
  tourFilter.value = {
    depDate: '',
    tourDurations: '',
    [`tourName${capitalize(currentLanguage)}`]: resetVal.name,
    type: resetVal.type,
    [`regionsVisited${capitalize(currentLanguage)}`]: resetVal.city
  };
  tourData.value = cloneDeep(tourSearchData);
};

const submitTours = (checkList: any) => {
  onApply(checkList);
};
</script>
<template>
  <div class="tour-select-table">
    <TourQuoteSearchFilter :tourData="tourSearchData" v-model:tourFilter="tourFilter" @handleApply="handleApplyFilter()" @handleReset="(resetVal) => handleResetFilter(resetVal)"></TourQuoteSearchFilter>
    <TourQuoteSearchList class="mt-3" :tourData="tourData" :selectedTours="selectedTours" :tourFilter="tourFilter" @handleSubmit="(checkList) => submitTours(checkList)"></TourQuoteSearchList>
  </div>
</template>
